export enum InternalEventTypes {
  MEMBER_CREATED = 0,
  MEMBER_DELETED = 1,
  MEMBER_UPDATED = 2,
  SALE_CREATED = 3,
  SALE_UPDATED = 4,
  PAYMENT_CREATED = 5,
  PAYMENT_UPDATED = 6,
  SALE_ITEM_CREATED = 7,
  SALE_ITEM_UPDATED = 8,
  SALE_SUCCESS = 9,
  SALE_FAILED = 10,
  SALE_DELETED = 20,
  SALE_CANCELED = 21,
  ORGANIZATION_CREATED = 11,
  ORGANIZATION_UPDATED = 12,
  MEMBER_LOGIN = 13,
  BOOKING_UPDATED = 14,
  BOOKING_DELETED = 19,
  USER_ROLE_UPDATED = 14,
  USER_ROLE_CREATED = 15,
  PARTICIPATION_CREATED = 16,
  PARTICIPATION_UPDATED = 17,
  PARTICIPATION_DELETED = 18,
  EMAIL_SENT = 22,
  OPERATION_UPDATED = 23,
  OPEN_ID_CREATED = 24,
  SALE_ITEM_DELETE = 25,
  ADDRESS_UPDATED = 26
}
